import PeopleIcon from '@mui/icons-material/People';
import { Datagrid, DateField, List, TextField } from 'react-admin';
export const GuestIcon = PeopleIcon;

const FormTemplateList = () => {
  return (
    <List queryOptions={{ refetchInterval: 5000 }} sort={{ field: 'updated_at', order: 'DESC' }}>
      <Datagrid rowClick="edit" optimized>
        <TextField source="id" />
        <TextField source="name" />
        <DateField source="updated_at" showTime locales="ja-JP" />
      </Datagrid>
    </List>
  );
};

export default FormTemplateList;
